<template>
  <article v-if="author" class="page">
    <section class="section font-roboto">
      <div class="mb-[100px] flex justify-start">
        <div class="flex w-full flex-col md:flex-row">
          <div
            class="flex max-h-[480px] w-full max-w-[720px] overflow-hidden rounded-xl md:w-1/2"
          >
            <img
              v-lazy-load
              :src="getSrc"
              :alt="
                author.image && author.image.alt
                  ? author.image.alt
                  : author.fullname
              "
              class="size-full object-cover"
            />
          </div>
          <div class="mt-8 flex w-full flex-col md:ml-14 md:mt-0 md:w-1/2">
            <h1 class="mb-5 text-[32px] font-medium leading-[38px]">
              {{ author.fullname }}
            </h1>
            <div
              class="mb-10 text-[20px] leading-[30px]"
              v-html="author.description || author.announce"
            ></div>
            <BaseTheButtonNew
              :text="
                isSubscribed ? 'Отписаться от автора' : 'Подписаться на автора'
              "
              type="secondary"
              @click.stop="handleSubscribe(author)"
            />
          </div>
        </div>
      </div>

      <h2
        class="text-7 mb-7 font-medium leading-[34px] xl:text-[28px] xl:leading-[34px]"
      >
        Материалы автора
      </h2>
      <div class="mb-9 flex w-full flex-col justify-between lg:flex-row">
        <CommonTabs
          :list="author.content_types"
          @on-change="selectedSortValue = $event"
        />
      </div>
      <div v-if="content?.length">
        <div class="grid grid-cols-1 gap-[20px] md:grid-cols-2 lg:grid-cols-3">
          <MainPageCardsReworkedBaseCard
            v-for="(item, index) in content"
            :key="`article-${item.id}-${index}`"
            class="col-span-1"
            :data="item"
            disable-announce
          />
        </div>
        <div class="my-14 flex justify-center">
          <BaseTheButtonNew
            v-if="authorContent.hasNextPage.value"
            text="Показать еще"
            @click="authorContent.fetchNextPage()"
          />
        </div>
      </div>
      <div
        v-else
        class="my-12 text-center font-roboto text-[32px] font-medium leading-[38px] text-new-gray-lighter"
      >
        В данной категории пока нет материалов
      </div>
    </section>
    <CommonBlocksPageFooterBlocks />
  </article>
</template>

<script setup>
const route = useRoute();
const slug = route?.params?.slug;

const selectedSortValue = ref('articles');

const { authorSlug } = useAuthorBySlug(slug);
const { authorContent } = useAuthorContent(slug, selectedSortValue);

const author = computed(() => authorSlug?.data?.value);
const content = computed(() => authorContent?.data?.value);

const { isSubscribed, handleSubscribe } = useAuthorSubscribeHandler(author);

const getSrc = computed(() => {
  const src =
    author.value?.image && author.value.image?.src
      ? author.value.image.src
      : null;

  if (!src) return '/imgs/default-image.png';
  return src;
});

useHead(
  computed(() => {
    return {
      title: `${
        author.value?.fullname ? `${author.value?.fullname} | ` : ''
      } Читать исторические документы РФ для школьников и студентов`,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: `Исторические статьи от автора ${author.value?.fullname}, точно описывающие реальные события, произошедшие в прошлом. Российское военно-историческое общество. Мы знаем правду.`,
        },
        {
          hid: 'keywords',
          name: 'keywords',
          content: `${author.value?.fullname}`,
        },
      ],
    };
  }),
);
</script>

<style lang="scss"></style>
